import React from 'react';
import { WEB_MODAL_MAX_WIDTH } from '../../theme/webLayoutWidths';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { Dialog, Portal, Text } from 'react-native-paper';
import { s } from '../../utils/libs';
import { useTheme, useThemeColors } from '../../theme';
import Calculator from '../Reusables/Calculator';
import { shouldUseWidthConstraint } from '../../utils/layoutUtils';

type Props = {
  visible: boolean;
  onDismiss: () => void;
  onSubmit?: (value: number, expression: string) => void;
  title?: string;
  storageKey?: string;
};

const CalculatorModal: React.FC<Props> = ({
  visible,
  onDismiss,
  onSubmit,
  title = 'Calculator',
  storageKey,
}) => {
  const { theme } = useTheme();
  const colors = useThemeColors();
  const { width, height } = useWindowDimensions();
  const constrainWidth = shouldUseWidthConstraint(width, height);
  return (
    <Portal>
      <Dialog
        visible={visible}
        onDismiss={onDismiss}
        style={[
          styles.dialog,
          { backgroundColor: theme.colors.surface },
          constrainWidth ? styles.dialogConstrained : null,
        ]}>
        <Dialog.Title style={{ color: colors.text }}>{title}</Dialog.Title>
        <Dialog.Content>
          <View style={{ width: '100%' }}>
            <Calculator
              variant="modal"
              onSubmit={onSubmit}
              onCancel={onDismiss}
              storageKey={storageKey}
            />
          </View>
        </Dialog.Content>
      </Dialog>
    </Portal>
  );
};

const styles = StyleSheet.create({
  dialog: {
    width: '92%',
    alignSelf: 'center',
    borderRadius: s(10),
  },
  dialogConstrained: {
    maxWidth: WEB_MODAL_MAX_WIDTH,
  },
});

export default CalculatorModal;
